import { render, staticRenderFns } from "./sp-setting-drawer.vue?vue&type=template&id=4aa81694"
import script from "./sp-setting-drawer.vue?vue&type=script&lang=ts"
export * from "./sp-setting-drawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VNavigationDrawer,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa81694')) {
      api.createRecord('4aa81694', component.options)
    } else {
      api.reload('4aa81694', component.options)
    }
    module.hot.accept("./sp-setting-drawer.vue?vue&type=template&id=4aa81694", function () {
      api.rerender('4aa81694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/layout/sp-setting-drawer.vue"
export default component.exports